module.exports = {
  isDomain(domains, equalDomain) {
    return domains.some(domain => domain === equalDomain);
  },

  isSubDomain(domains, subdomain) {
    return domains.some((domain) => {
      if (typeof domain === 'string' && domain.trim() !== '') {
        if (domain === subdomain || subdomain.endsWith(`.${domain}`)) {
          return true;
        }
      }
      return false;
    });
  },

  isSubDomainRegex(domainRegexs, domain) {
    return domainRegexs.some((regexString) => {
      const regex = RegExp(regexString);
      return regex.test(domain);
    });
  },

  checkHostname(hostname) {
    // Reference: https://blog.walterlv.com/post/match-web-url-using-regex.html
    const domainRegex = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
    return domainRegex.test(hostname);
  },

};
